import { checkParameters } from "./utils/checkParameters";
import { isAllowedUri } from "./utils/validateUri";
let parameters = undefined;
export const validateParameters = (pathConfig) => {
    var _a;
    parameters = new URLSearchParams(window.location.search);
    try {
        checkParameters(parameters, pathConfig);
    }
    catch (error) {
        console.warn(error);
    }
    if (parameters.get("channel") !== "mobile") {
        (_a = document.getElementById("minimal-ui-treadmill")) === null || _a === void 0 ? void 0 : _a.remove();
        document.body.style.overflow = "hidden";
    }
};
export const sanitizeParameters = (layerConfig) => {
    const homeurl = parameters === null || parameters === void 0 ? void 0 : parameters.get("homeurl");
    if (homeurl != null) {
        if (!homeurl.startsWith("action:") && !isAllowedUri(homeurl, layerConfig)) {
            parameters === null || parameters === void 0 ? void 0 : parameters.set("homeurl", "");
        }
    }
};
export const getParameter = (name) => {
    if (!parameters) {
        console.error("getParameter error: Attempting to get a parameter before validation");
        return null;
    }
    return parameters.get(name);
};
export const getGameRefParameter = () => {
    var _a;
    if (process.env.MODE === "development") {
        return (_a = getParameter("gameref")) !== null && _a !== void 0 ? _a : getParameter("gameid");
    }
    else {
        return getParameter("gameid");
    }
};
export const getLobbyIdParameter = () => {
    const provider = getParameter("provider");
    const lobbyId = getParameter("lobbyid");
    if (provider !== null && lobbyId !== null) {
        return `rlx.${provider}.${provider}.${lobbyId}`;
    }
    return null;
};
export const getValidatedParameters = () => {
    return new URLSearchParams(parameters);
};
